/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { useMantineColorScheme } from '@mantine/core';
import { renderCompactNumber, dateRendererForChart } from '../../../utilities/general';

const getFormattedValue = (key, value, config) => {
  if (Array.isArray(value) && typeof value[0] === 'string') {
    const mapped = value.map((val) => config?.props?.displayMapping?.[val] || val);
    const shown = mapped.slice(0, 2).join(', ');
    const extra = mapped.length > 2 ? ` +${mapped.length - 2} other${mapped.length > 3 ? 's' : ''}` : '';
    return shown + extra;
  }

  if (Array.isArray(value) && typeof value[0] === 'number' && config?.type === 'range') {
    const [min, max] = value;
    return `${renderCompactNumber(min, true)} - ${renderCompactNumber(max, true)}`;
  }

  if (Array.isArray(value) && typeof value[0] === 'number' && config?.type === 'number') {
    const [min, max] = value;
    return `${min}% - ${max}%`;
  }
  if (Array.isArray(value) && typeof value[0] === 'number' && config?.type === 'dropdown') {
    const [min, max] = value;
    return `${renderCompactNumber(min, true)} - ${renderCompactNumber(max, true)}`;
  }
  if (Array.isArray(value?.dateRange) && value.dateRange[0] && value.dateRange[1] && config?.type === 'dateRange') {
    const [startDate, endDate] = value?.dateRange;
    // return `${displayDateInUtc(startDate)} - ${displayDateInUtc(endDate)}`;
    if (startDate && endDate) {
      // return `${displayDateInUtc(startDate)} - ${displayDateInUtc(endDate)}`;
      return `${dateRendererForChart(startDate)} - ${dateRendererForChart(endDate)}`;
    }
  }

  if (typeof value === 'string') {
    return config?.props?.displayMapping?.[value] || value;
  }

  return value;
};

const AppliedFiltersSummary = ({
  appliedFilters,
  filterConfig,
  currentTab,
  onClick,
  showAllFilters = false,
}) => {
  const { colorScheme } = useMantineColorScheme();
  const content = useMemo(() => {
    const activeFilters = Object.entries(appliedFilters).filter(
      ([_, value]) => value && (!Array.isArray(value) || value.length > 0),
    );

    if (activeFilters.length === 0) return null;

    const filterPills = showAllFilters
      ? activeFilters.map(([key, value]) => {
        const config = filterConfig[currentTab]?.find(
          (conf) => conf.props?.fieldKey === key || conf.props?.parentKey === key,
        );
        const label = config?.props?.title || key;
        const displayValue = getFormattedValue(key, value, config);

        return (
          <div
            key={key}
            onClick={onClick}
            className={`${colorScheme === 'dark' ? 'bg-[#1A2E3B] text-[#4FC3F7]' : 'bg-[#E7F6FF] text-[#0093EF]'} text-sm font-semibold px-2 py-1 rounded-md cursor-pointer mr-2`}
          >
            {`${label}: ${displayValue}`}
          </div>
        );
      })
      : (() => {
        const [firstKey, firstValue] = activeFilters[0];
        const firstConfig = filterConfig[currentTab]?.find(
          (conf) => conf.props?.fieldKey === firstKey || conf.props?.parentKey === firstKey,
        );
        const firstLabel = firstConfig?.props?.title || firstKey;
        const firstDisplayValue = getFormattedValue(firstKey, firstValue, firstConfig);

        return (
          <>
            <div
              onClick={onClick}
              className={`${colorScheme === 'dark' ? 'bg-[#1A2E3B] text-[#4FC3F7]' : 'bg-[#E7F6FF] text-[#0093EF]'} text-sm font-semibold px-2 py-1 rounded-md cursor-pointer mr-2`}
            >
              {`${firstLabel}: ${firstDisplayValue}`}
            </div>
            {activeFilters.length > 1 && (
              <div
                onClick={onClick}
                className={`${colorScheme === 'dark' ? 'bg-[#1A2E3B] text-[#4FC3F7]' : 'bg-[#E7F6FF] text-[#0093EF]'} text-sm font-semibold px-2 py-1 rounded-md cursor-pointer mr-2`}
              >
                {`+ ${activeFilters.length - 1} More Filter${activeFilters.length > 2 ? 's' : ''}`}
              </div>
            )}
          </>
        );
      })();

    return <div className="flex items-center flex-wrap gap-2">{filterPills}</div>;
  }, [appliedFilters, filterConfig, currentTab, onClick, showAllFilters]);

  return content;
};

export default AppliedFiltersSummary;
